export const el = {
  app: {
    name: 'BalanceFlow',
    subtitle: 'Διαχείριση πελατών & υπολοίπων',
  },
  nav: {
    home: 'Αρχική',
    customers: 'Πελάτες',
    shipmentFiles: 'Φάκελοι μεταφοράς',
    shipmentFilesList: 'Λίστα φακέλων',
    invoices: 'Τιμολόγια / Χρεώσεις',
    payments: 'Πληρωμές',
    companyExpenses: 'Δαπάνες',
    companyExpensesList: 'Λίστα δαπανών',
    companyExpensePayables: 'Προς πληρωμή',
    companyExpenseSummary: 'Ανά κατηγορία',
    mydata: 'myDATA',
    mydataPeriod: 'Έσοδα / Έξοδα / ΦΠΑ',
    mydataSync: 'Συγχρονισμός',
    mydataDebts: 'ΦΠΑ',
    mydataDocuments: 'Παραστατικά',
    mydataPdfExport: 'Λήψη PDF μήνα',
    mydataConnection: 'Σύνδεση ΑΑΔΕ',
    reports: 'Οικονομικά',
    monthlySummary: 'Μηνιαία Σύνοψη',
    yearlyMonthly: 'Ετήσια Ανάλυση',
    customerBalances: 'Υπόλοιπα Πελατών',
    aging: 'Ληξιπρόθεσμες Οφειλές',
    categorySummary: 'Ανάλυση ανά Κατηγορία',
    unallocatedPayments: 'Μη Κατανεμημένες Πληρωμές',
    agreementVariance: 'Απόκλιση Συμφωνίας',
    shipmentReports: 'Φάκελοι',
    shipmentMonthlySummary: 'Μηνιαία Φακέλων',
    shipmentExpenseCategories: 'Κατηγορίες Εξόδων Φακέλων',
    shipmentOpenFiles: 'Ανοιχτοί Φάκελοι',
    shipmentByCustomer: 'Φάκελοι ανά Πελάτη',
    shipmentContainerBl: 'Container / B/L',
    shipmentExpenseAnalysis: 'Ανάλυση Εξόδων Φακέλων',
    shipmentByPortVessel: 'Φάκελοι ανά Λιμάνι/Πλοίο',
    companyExpenseReports: 'Δαπάνες',
    companyExpenseYearlyMonthly: 'Ετήσια Δαπανών',
    companyExpenseByVendor: 'Ανά Προμηθευτή',
    companyExpenseTypeAnalysis: 'Ανάλυση Τύπου',
    companyExpensePayments: 'Πληρωμές Περιόδου',
    companyExpenseAging: 'Aging Δαπανών',
    settings: 'Ρυθμίσεις',
    invoiceCategories: 'Κατηγορίες Τιμολογίων',
    expenseCategories: 'Κατηγορίες εξόδων μεταφοράς',
    companyExpenseCategories: 'Κατηγορίες δαπανών',
    office: 'Παράρτημα',
    users: 'Χρήστες',
    logout: 'Αποσύνδεση',
    openMenu: 'Μενού',
    closeMenu: 'Κλείσιμο',
    collapseSidebar: 'Σύμπτυξη μενού',
    expandSidebar: 'Επέκταση μενού',
    themeLight: 'Φωτεινό θέμα',
    themeDark: 'Σκοτεινό θέμα',
    platformTenants: 'Επιχειρήσεις',
  },
  tenantSetup: {
    title: 'Στοιχεία επιχείρησης',
    hint: 'Συμπληρώστε τα στοιχεία της επιχείρησης για να συνεχίσετε.',
    companyName: 'Επωνυμία',
    vatNumber: 'ΑΦΜ',
    email: 'Email',
    phone: 'Τηλέφωνο',
    address: 'Διεύθυνση',
    notes: 'Σημειώσεις',
    submit: 'Ολοκλήρωση',
    requiredName: 'Η επωνυμία είναι υποχρεωτική',
  },
  platform: {
    title: 'Διαχείριση πλατφόρμας',
    subtitle: 'Επιχειρήσεις',
    brandTag: 'Πλατφόρμα',
    signedInAs: 'Συνδεδεμένος ως',
    newTenant: 'Νέα επιχείρηση',
    created: 'Η επιχείρηση δημιουργήθηκε επιτυχώς.',
    requiredFields: 'Συμπληρώστε όλα τα υποχρεωτικά πεδία.',
    searchPlaceholder: 'Αναζήτηση επιχείρησης ή slug…',
    statsTotal: 'Σύνολο επιχειρήσεων',
    statsActive: 'Ενεργές',
    statsPending: 'Εκκρεμής ρύθμιση',
    colName: 'Επιχείρηση',
    colSlug: 'Slug',
    colUsers: 'Χρήστες',
    colCustomers: 'Πελάτες',
    colSetup: 'Ρύθμιση',
    colActive: 'Κατάσταση',
    setupDone: 'Ολοκληρώθηκε',
    setupPending: 'Εκκρεμεί',
    statusActive: 'Ενεργή',
    statusInactive: 'Ανενεργή',
    emptyTitle: 'Καμία επιχείρηση',
    emptyHint:
      'Δημιουργήστε την πρώτη επιχείρηση (εταιρεία ή ατομική) για να ξεκινήσετε.',
    companyName: 'Επωνυμία επιχείρησης',
    slug: 'Slug',
    slugHint: 'Μόνο πεζά λατινικά, αριθμοί και παύλες (εσωτερική αναφορά).',
    firstAdmin: 'Πρώτος διαχειριστής',
    firstAdminHint:
      'Θα λάβει σύνδεσμο πρόσκλησης για να ορίσει κωδικό και να μπει στην επιχείρηση.',
    adminName: 'Όνομα',
    adminEmail: 'Email',
    adminPassword: 'Προσωρινός κωδικός (προαιρετικό)',
    adminPasswordHint:
      'Αφήστε κενό — ο διαχειριστής θα ορίσει κωδικό από την πρόσκληση.',
    modalIntro:
      'Η νέα επιχείρηση ξεκινά κενή. Στείλτε την πρόσκληση στον διαχειριστή.',
    inviteReadyTitle: 'Η πρόσκληση είναι έτοιμη',
    inviteReadyHint:
      'Ελέγξτε την προεπισκόπηση και στείλτε το email απευθείας στον διαχειριστή.',
    inviteLink: 'Σύνδεσμος πρόσκλησης',
    inviteEmailPreview: 'Προεπισκόπηση email',
    inviteSubject: 'Θέμα',
    copyLink: 'Αντιγραφή συνδέσμου',
    copied: 'Αντιγράφηκε',
    sendInviteEmail: 'Αποστολή email',
    inviteEmailSent: 'Το email στάλθηκε στο {email}.',
    sendEmail: 'Άνοιγμα email',
    closeInvite: 'Κλείσιμο',
    resendInvite: 'Νέα πρόσκληση',
    invitePending: 'Εκκρεμεί πρόσκληση',
    inviteAccepted: 'Έχει συνδεθεί',
    colPackage: 'Πακέτο',
    packageFrom: 'Έναρξη πακέτου',
    packageTo: 'Λήξη πακέτου',
    packageHint: 'Ετήσια περίοδος συνδρομής (συμπεριλαμβανομένης της ημερομηνίας λήξης).',
    packageStatusActive: 'Ενεργό',
    packageStatusUpcoming: 'Προσεχώς',
    packageStatusExpired: 'Ληγμένο',
    packageStatusDisabled: 'Ανενεργό',
    editPackage: 'Πακέτα',
    packageSaved: 'Το πακέτο αποθηκεύτηκε.',
    statsExpired: 'Ληγμένα πακέτα',
    renewPackage: 'Νέο πακέτο (+1 έτος)',
    renewed: 'Προστέθηκε νέο πακέτο.',
    renewConfirmTitle: 'Νέο πακέτο',
    renewConfirmMessage:
      'Να προστεθεί νέο πακέτο για ένα έτος μετά την τελευταία λήξη;',
    managePackage: 'Πακέτο',
    renewalsTitle: 'Πακέτα',
    renewalsCount: 'Ανανεώσεις',
    renewalKindInitial: 'Αρχικό',
    renewalKindRenewal: 'Ανανέωση',
    renewalKindManual: 'Αλλαγή',
    renewalKindCancelled: 'Ακύρωση',
    noRenewals: 'Δεν υπάρχει πακέτο. Ορίστε ημερομηνίες και αποθηκεύστε.',
    renewalKindCol: 'Τύπος',
    deleteRenewal: 'Διαγραφή',
    deleteRenewalConfirmTitle: 'Διαγραφή πακέτου',
    deleteRenewalConfirmMessage: 'Να διαγραφεί αυτό το πακέτο;',
    renewalDeleted: 'Το πακέτο διαγράφηκε.',
    createPackage: 'Δημιουργία πακέτου',
    editRenewal: 'Επεξεργασία',
    changePassword: 'Αλλαγή κωδικού',
    changePasswordTitle: 'Αλλαγή κωδικού',
    currentPassword: 'Τρέχων κωδικός',
    newPassword: 'Νέος κωδικός',
    confirmNewPassword: 'Επιβεβαίωση νέου κωδικού',
    passwordChanged: 'Ο κωδικός άλλαξε επιτυχώς.',
    passwordMin: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
    passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν',
    savePassword: 'Αποθήκευση',
    tabTenants: 'Επιχειρήσεις',
    tabAdmins: 'Διαχειριστές πλατφόρμας',
    tabAuditLogs: 'Αρχείο ενεργειών',
    tabPackages: 'Πακέτα λειτουργιών',
    tabSettings: 'Ρυθμίσεις εφαρμογής',
    packagesTitle: 'Πακέτα λειτουργιών',
    packagesHint:
      'Ορίστε πακέτα (π.χ. Basic, Advanced, Φάκελοι) επιλέγοντας ποιες οθόνες περιλαμβάνουν. Έπειτα ενεργοποιήστε τα ανά επιχείρηση.',
    newPackage: 'Νέο πακέτο',
    editPackageFeatures: 'Επεξεργασία πακέτου',
    packageCreated: 'Το πακέτο δημιουργήθηκε.',
    packageUpdated: 'Το πακέτο ενημερώθηκε.',
    packagesEmptyTitle: 'Κανένα πακέτο',
    packagesEmptyHint: 'Δημιουργήστε το πρώτο πακέτο λειτουργιών.',
    packageName: 'Όνομα πακέτου',
    packageCode: 'Κωδικός',
    packageCodeHint: 'Πεζά λατινικά, αριθμοί ή _ (π.χ. basic).',
    packageDescription: 'Περιγραφή',
    packageFeatures: 'Λειτουργίες / οθόνες',
    packageFeaturesHint:
      'Όλες οι οθόνες και κατηγορίες του μενού. Οι πάντα διαθέσιμες είναι κλειδωμένες· επιλέξτε τις υπόλοιπες για το πακέτο.',
    packageAlwaysOn: 'Πάντα διαθέσιμα',
    packageAlwaysOnShort: 'πάντα',
    packageMenuMain: 'Κύριο μενού',
    packageMenuReports: 'Οικονομικά',
    packageMenuShipmentReports: 'Φάκελοι',
    packageMenuCompanyExpenses: 'Δαπάνες',
    packageMenuCompanyExpenseReports: 'Αναφορές δαπανών',
    packageMenuMydata: 'myDATA',
    packageMenuSettings: 'Ρυθμίσεις',
    packageMenuOther: 'Άλλες λειτουργίες',
    packageActive: 'Ενεργό',
    packageFeaturesCol: 'Λειτουργίες',
    packageTenantsCol: 'Επιχειρήσεις',
    requiredPackageFields: 'Συμπληρώστε όνομα και κωδικό.',
    manageAppPackages: 'Λειτουργίες',
    manageAppPackagesTitle: 'Πακέτα λειτουργιών επιχείρησης',
    appPackagesHint:
      'Ενεργοποιήστε τα πακέτα που ισχύουν για αυτή την επιχείρηση. Οι οθόνες είναι η ένωση όλων των ενεργών πακέτων.',
    appPackagesSaved: 'Τα πακέτα λειτουργιών αποθηκεύτηκαν.',
    effectiveFeatures: 'Ενεργές λειτουργίες',
    noAppPackages: 'Δεν υπάρχουν διαθέσιμα πακέτα.',
    adminsTitle: 'Διαχειριστές πλατφόρμας',
    adminsHint:
      'Χρήστες με πλήρη πρόσβαση στη διαχείριση επιχειρήσεων και πακέτων.',
    newAdmin: 'Νέος διαχειριστής',
    adminCreated: 'Ο διαχειριστής δημιουργήθηκε. Στείλτε την πρόσκληση.',
    adminUpdated: 'Ο διαχειριστής ενημερώθηκε.',
    adminsEmptyTitle: 'Κανένας διαχειριστής',
    adminsEmptyHint: 'Προσθέστε τουλάχιστον έναν διαχειριστή πλατφόρμας.',
    colAdminName: 'Όνομα',
    colAdminEmail: 'Email',
    colAdminInvite: 'Πρόσκληση',
    editAdmin: 'Επεξεργασία',
    adminOptionalPassword: 'Προσωρινός κωδικός (προαιρετικό)',
    adminOptionalPasswordHint:
      'Αφήστε κενό — θα ορίσει κωδικό από τον σύνδεσμο πρόσκλησης.',
    platformInviteLabel: 'Πλατφόρμα BalanceFlow',
    youBadge: 'Εσείς',
    enterTenant: 'Είσοδος',
    enterTenantTitle: 'Είσοδος στην επιχείρηση χωρίς κωδικό (υποστήριξη)',
    supportBanner:
      'Λειτουργία υποστήριξης — βλέπετε τα δεδομένα της επιχείρησης {name}.',
    supportExit: 'Επιστροφή στην πλατφόρμα',
  },
  platformSettings: {
    hint: 'Ρυθμίσεις που ισχύουν για όλη την πλατφόρμα BalanceFlow.',
    smtpSection: 'Email (SMTP)',
    smtpHint:
      'Απαιτούνται για την αποστολή προσκλήσεων νέων επιχειρήσεων από την πλατφόρμα.',
    mailReady: 'Η αποστολή email είναι ενεργή.',
    mailNotReady: 'Η αποστολή email δεν είναι ακόμη ρυθμισμένη (λείπει το SMTP host).',
    smtpHost: 'SMTP Host',
    smtpPort: 'Θύρα',
    smtpSecure: 'SSL/TLS (secure)',
    smtpUser: 'Όνομα χρήστη',
    smtpPass: 'Κωδικός',
    smtpPassPlaceholder: 'Κωδικός SMTP',
    smtpPassKeep: 'Αφήστε κενό για να διατηρηθεί ο υπάρχων',
    smtpPassHintSet: 'Υπάρχει αποθηκευμένος κωδικός. Συμπληρώστε μόνο αν θέλετε αλλαγή.',
    smtpPassHintEmpty: 'Ο κωδικός αποθηκεύεται στη βάση και δεν εμφανίζεται ξανά στην οθόνη.',
    mailFrom: 'Αποστολέας (From)',
    invalidPort: 'Μη έγκυρη θύρα SMTP.',
    saved: 'Οι ρυθμίσεις αποθηκεύτηκαν.',
  },
  invite: {
    title: 'Ορισμός κωδικού',
    hint: 'Ολοκληρώστε την πρόσκληση για να μπείτε στην επιχείρηση.',
    office: 'Επιχείρηση',
    platformOffice: 'Πλατφόρμα',
    email: 'Email',
    password: 'Νέος κωδικός',
    confirmPassword: 'Επιβεβαίωση κωδικού',
    submit: 'Ορισμός κωδικού & είσοδος',
    passwordMin: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
    passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν',
    invalidInvite: 'Η πρόσκληση δεν είναι έγκυρη ή έχει λήξει',
    backToLogin: 'Πίσω στη σύνδεση',
  },
  auth: {
    loginTitle: 'Σύνδεση',
    loginWelcome: 'Καλώς ήρθατε',
    loginHint: 'Εισέλθετε με τα στοιχεία του λογαριασμού σας.',
    email: 'Email',
    password: 'Κωδικός',
    submit: 'Είσοδος',
    invalidCredentials: 'Μη έγκυρα στοιχεία σύνδεσης',
    requiredEmail: 'Το email είναι υποχρεωτικό',
    requiredPassword: 'Ο κωδικός είναι υποχρεωτικός',
    invalidEmail: 'Το email δεν είναι έγκυρο',
    emailPlaceholder: 'name@office.gr',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'Ξεχάσατε τον κωδικό;',
    sessionExpired: 'Η συνεδρία έληξε. Παρακαλώ συνδεθείτε ξανά.',
    tooManyRequests: 'Πάρα πολλά αιτήματα. Δοκιμάστε ξανά σε λίγο.',
    panelTagline:
      'Ολοκληρωμένη διαχείριση πελατών, τιμολογίων και υπολοίπων για την επιχείρησή σας.',
    featureBalances: 'Υπόλοιπα πελατών σε πραγματικό χρόνο',
    featureInvoices: 'Τιμολόγια, πληρωμές και συμφωνίες',
    featureReports: 'Αναφορές και εξαγωγές για καθημερινή χρήση',
  },
  forgotPassword: {
    title: 'Επαναφορά κωδικού',
    hint: 'Εισάγετε το email του λογαριασμού σας. Θα σας στείλουμε σύνδεσμο επαναφοράς.',
    submit: 'Αποστολή συνδέσμου',
    sent: 'Αν υπάρχει λογαριασμός με αυτό το email, θα λάβετε σύνδεσμο επαναφοράς.',
    backToLogin: 'Πίσω στη σύνδεση',
  },
  resetPassword: {
    title: 'Νέος κωδικός',
    hint: 'Ορίστε νέο κωδικό για τον λογαριασμό σας.',
    password: 'Νέος κωδικός',
    confirmPassword: 'Επιβεβαίωση κωδικού',
    submit: 'Αποθήκευση & είσοδος',
    passwordMin: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
    passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν',
    invalidLink: 'Ο σύνδεσμος επαναφοράς δεν είναι έγκυρος ή έχει λήξει',
    requestAgain: 'Αίτημα νέου συνδέσμου',
    backToLogin: 'Πίσω στη σύνδεση',
  },
  auditLogs: {
    hint: 'Καταγραφή όλων των σημαντικών ενεργειών στην πλατφόρμα και στις επιχειρήσεις.',
    search: 'Αναζήτηση',
    searchPlaceholder: 'Email, περιγραφή, διαδρομή…',
    action: 'Ενέργεια',
    entityType: 'Οντότητα',
    from: 'Από',
    to: 'Έως',
    allActions: 'Όλες οι ενέργειες',
    allEntities: 'Όλες οι οντότητες',
    applyFilters: 'Εφαρμογή',
    empty: 'Δεν βρέθηκαν καταγραφές.',
    colWhen: 'Ημ/νία',
    colActor: 'Χρήστης',
    colAction: 'Ενέργεια',
    colEntity: 'Οντότητα',
    colSummary: 'Περιγραφή',
    colIp: 'IP',
    colMethod: 'Αίτημα',
    colStatus: 'HTTP',
    colUserAgent: 'User-Agent',
    colMetadata: 'Λεπτομέρειες',
    pageOf: 'Σελίδα {page} από {total} ({count} εγγραφές)',
    prev: 'Προηγούμενο',
    next: 'Επόμενο',
  },
  common: {
    loading: 'Φόρτωση...',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    close: 'Κλείσιμο',
    search: 'Αναζήτηση',
    clearFilters: 'Καθαρισμός',
    actions: 'Ενέργειες',
    empty: 'Δεν βρέθηκαν εγγραφές.',
    error: 'Παρουσιάστηκε σφάλμα',
    comingSoon: 'Η ενότητα θα είναι διαθέσιμη σε επόμενη φάση.',
    welcome: 'Καλώς ήρθατε',
    accessDenied: 'Δεν έχετε δικαίωμα πρόσβασης σε αυτή την ενότητα.',
    backToList: '← Πίσω στη λίστα',
    backList: '← Λίστα',
    back: 'Πίσω',
    amountMustBePositive: 'Το ποσό πρέπει να είναι μεγαλύτερο από μηδέν.',
    inactiveSuffix: ' (ανενεργή)',
    remainingLabel: 'υπόλοιπο',
    noVat: 'Χωρίς ΑΦΜ',
    vatPrefix: 'ΑΦΜ',
    date: 'Ημ/νία',
    yes: 'Ναι',
    no: 'Όχι',
    total: 'Σύνολο',
    customer: 'Πελάτης',
    months: [
      'Ιανουάριος',
      'Φεβρουάριος',
      'Μάρτιος',
      'Απρίλιος',
      'Μάιος',
      'Ιούνιος',
      'Ιούλιος',
      'Αύγουστος',
      'Σεπτέμβριος',
      'Οκτώβριος',
      'Νοέμβριος',
      'Δεκέμβριος',
    ],
    weekdaysShort: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πε', 'Πα', 'Σα'],
    placeholders: {
      text: '',
      number: '',
      select: '— Επιλέξτε —',
      search: 'Αναζήτηση…',
      searchType: 'Πληκτρολογήστε για αναζήτηση…',
      date: 'Επιλέξτε ημερομηνία',
      dateFormat: 'ΗΗ/ΜΜ/ΕΕΕΕ',
      amount: '0,00',
    },
  },
  dashboard: {
    title: 'Αρχική',
    placeholder:
      'Ο πίνακας ελέγχου θα εμφανίζει χρεώσεις, πληρωμές και ληξιπρόθεσμα υπόλοιπα.',
    monthCharges: 'Χρεώσεις Μήνα',
    monthPayments: 'Πληρωμές Μήνα',
    totalBalance: 'Συνολικό Υπόλοιπο',
    overdueBalance: 'Ληξιπρόθεσμο Υπόλοιπο',
    shipmentOpenCount: 'Ανοιχτοί φάκελοι',
    shipmentOpenBillable: 'Χρεώσιμα ανοιχτών φακέλων',
    shipmentInvoicedMonth: 'Τιμολογημένοι φάκελοι μήνα',
    companyExpenseOverdue: 'Ληξιπρόθεσμες δαπάνες',
    companyExpenseDue7Days: 'Δαπάνες επόμενων 7 ημερών',
    agingTitle: 'Ληξιπρόθεσμες Οφειλές',
    topDebtors: 'Πελάτες με Μεγαλύτερο Υπόλοιπο',
    lastPaymentDate: 'Τελευταία Πληρωμή',
    daysSinceLastPayment: 'Ημ. χωρίς πληρωμή',
    openInvoices: 'Ανοιχτά τιμ.',
    balanceInvoice: 'Υπ. Τιμ.',
    balanceCash: 'Υπ. Μετρ.',
    balanceTotal: 'Συν. Υπόλ.',
    viewReports: 'Αναφορές',
    viewAging: 'Λεπτομέρειες aging',
    noActiveSections:
      'Δεν υπάρχουν ενεργά πακέτα με δεδομένα για την αρχική. Ενεργοποιήστε πακέτα από τη διαχείριση πλατφόρμας.',
  },
  usersSettings: {
    title: 'Χρήστες',
    new: 'Νέος Χρήστης',
    invite: 'Πρόσκληση χρήστη',
    noLogin: 'Χωρίς σύνδεση',
    noLoginTitle: 'Χρήστης χωρίς σύνδεση',
    noLoginHint:
      'Ο χρήστης καταχωρείται χωρίς πρόσκληση και δεν μπορεί να συνδεθεί. Από την επεξεργασία μπορείς αργότερα να του στείλεις πρόσκληση.',
    inviteNoLoginHint:
      'Συμπλήρωσε email και ρόλο και στείλε πρόσκληση για να μπορεί να συνδεθεί.',
    inviteTitle: 'Πρόσκληση χρήστη',
    inviteHint:
      'Θα σταλεί email με σύνδεσμο για ορισμό κωδικού. Δεν χρειάζεται προσωρινός κωδικός.',
    sendInvite: 'Αποστολή πρόσκλησης',
    inviteSent: 'Η πρόσκληση στάλθηκε με email.',
    inviteCreatedNoEmail:
      'Η πρόσκληση δημιουργήθηκε, αλλά το email δεν στάλθηκε. Αντιγράψτε τον σύνδεσμο ή ρυθμίστε SMTP.',
    inviteReadyTitle: 'Η πρόσκληση είναι έτοιμη',
    inviteLink: 'Σύνδεσμος πρόσκλησης',
    copyLink: 'Αντιγραφή συνδέσμου',
    copied: 'Αντιγράφηκε',
    closeInvite: 'Κλείσιμο',
    inviteStatus: 'Πρόσκληση',
    invitePending: 'Εκκρεμεί',
    inviteAccepted: 'Ενεργός',
    resendInvite: 'Επανποστολή',
    deleteInvite: 'Διαγραφή',
    deleteInviteTitle: 'Διαγραφή πρόσκλησης',
    deleteInviteMessage:
      'Να διαγραφεί οριστικά η εκκρεμής πρόσκληση για {email};',
    deleteInviteSuccess: 'Η πρόσκληση διαγράφηκε.',
    deleteUserTitle: 'Διαγραφή χρήστη',
    deleteUserMessage:
      'Να διαγραφεί ο χρήστης «{name}»; Η ενέργεια δεν αναιρείται.',
    deleteUserSuccess: 'Ο χρήστης διαγράφηκε.',
    edit: 'Επεξεργασία Χρήστη',
    name: 'Όνομα',
    email: 'Email',
    password: 'Κωδικός',
    passwordKeep: 'Αφήστε κενό για να μην αλλάξει',
    role: 'Ρόλος',
    office: 'Παράρτημα',
    active: 'Ενεργός',
    inactive: 'Ανενεργός',
    admin: 'Διαχειριστής',
    user: 'Χρήστης',
    requiredName: 'Το όνομα είναι υποχρεωτικό.',
    requiredEmail: 'Το email είναι υποχρεωτικό.',
    requiredPassword: 'Ο κωδικός είναι υποχρεωτικός.',
    saveSuccess: 'Ο χρήστης αποθηκεύτηκε επιτυχώς.',
  },
  offices: {
    title: 'Παράρτημα',
    new: 'Νέο παράρτημα',
    edit: 'Επεξεργασία παραρτήματος',
    name: 'Όνομα',
    active: 'Ενεργό',
    inactive: 'Ανενεργό',
    requiredName: 'Το όνομα είναι υποχρεωτικό.',
    saveSuccess: 'Το παράρτημα αποθηκεύτηκε.',
    deactivate: 'Απενεργοποίηση',
  },
  financial: {
    invoice: 'Τιμολόγιο',
    cash: 'Μετρητά',
    invoiceTotal: 'Σύν. Τιμ.',
    cashTotal: 'Σύν. Μετρ.',
    grandTotal: 'Σύνολο',
    type: 'Τύπος',
    amount: 'Ποσό',
    description: 'Περιγραφή',
    addLine: '+ Προσθήκη Γραμμής',
    removeLine: 'Αφαίρεση',
  },
  customers: {
    title: 'Πελάτες',
    new: 'Νέος Πελάτης',
    edit: 'Επεξεργασία Πελάτη',
    details: 'Καρτέλα Πελάτη',
    name: 'Επωνυμία',
    vatNumber: 'ΑΦΜ',
    email: 'Email',
    phone: 'Τηλέφωνο',
    address: 'Διεύθυνση',
    notes: 'Παρατηρήσεις',
    accountingBooksCategory: 'Κατηγορία Λογιστικών Βιβλίων',
    booksSingleEntry: 'Β΄ Απλογραφικά',
    booksDoubleEntry: 'Γ΄ Διπλογραφικά',
    prefecture: 'Νομός',
    assignedUser: 'Υπεύθυνος',
    responsibleOffice: 'Υπεύθυνο Παράρτημα',
    creditDays: 'Ημέρες Πίστωσης',
    active: 'Ενεργός',
    inactive: 'Ανενεργός',
    status: 'Κατάσταση',
    agreedAmount: 'Συμφ. Ποσό',
    outstandingBalance: 'Υπόλοιπο',
    listCustomerCountOne: '{count} πελάτης',
    listCustomerCount: '{count} πελάτες',
    searchPlaceholder: 'Αναζήτηση (όνομα, ΑΦΜ, email, τηλέφωνο)',
    filterAll: 'Όλοι',
    filterActive: 'Ενεργοί',
    filterInactive: 'Ανενεργοί',
    createSuccess: 'Ο πελάτης δημιουργήθηκε επιτυχώς.',
    updateSuccess: 'Οι αλλαγές αποθηκεύτηκαν επιτυχώς.',
    agreementSection: 'Οικονομική Συμφωνία',
    agreementNotes: 'Σημειώσεις συμφωνίας',
    requiredName: 'Το πεδίο "Πελάτης" είναι υποχρεωτικό.',
    view: 'Προβολή',
    editAction: 'Επεξεργασία',
    activate: 'Ενεργοποίηση',
    deactivate: 'Απενεργοποίηση',
    tabs: {
      overview: 'Επισκόπηση',
      agreement: 'Συμφωνία',
      invoices: 'Τιμολόγια / Χρεώσεις',
      payments: 'Πληρωμές',
      statement: 'Καρτέλα Πελάτη',
    },
    noAgreement: 'Δεν υπάρχει αποθηκευμένη συμφωνία.',
    totalCharges: 'Συνολικές Χρεώσεις',
    totalPayments: 'Συνολικές Πληρωμές',
    balance: 'Υπόλοιπο',
    statementEmpty: 'Δεν υπάρχουν κινήσεις.',
    statementView: 'Προβολή',
    statementAll: 'Όλες',
    statementOpenInvoices: 'Ανοιχτά',
    statementOpenEmpty: 'Δεν υπάρχουν ανοιχτά τιμολόγια.',
    statementPaidEmpty: 'Δεν υπάρχουν εξοφλημένα τιμολόγια.',
    statementOverdueEmpty: 'Δεν υπάρχουν ληξιπρόθεσμα τιμολόγια.',
    invoiceStatusView: 'Κατάσταση',
    movementType: 'Κίνηση',
    reference: 'Αναφορά',
    runningInvoice: 'Υπ. Τιμ.',
    runningCash: 'Υπ. Μετρ.',
    runningTotal: 'Συν. Υπόλ.',
    invoiceMovement: 'Τιμολόγιο',
    paymentMovement: 'Πληρωμή',
    exportExcel: 'Εξαγωγή Excel',
    exportPdf: 'Εξαγωγή PDF',
    printedAt: 'Εκτυπώθηκε',
    page: 'Σελίδα',
    pageOf: 'από',
    delete: 'Διαγραφή',
    deleteConfirm:
      'Να διαγραφεί οριστικά ο πελάτης «{name}»; Θα διαγραφούν και όλα τα τιμολόγια, οι πληρωμές και η συμφωνία του. Η ενέργεια δεν αναιρείται.',
    deleteSuccess: 'Ο πελάτης διαγράφηκε.',
    matchBoard: 'Σύνδεση τιμολογίων',
    matchBoardTitle: 'Σύνδεση τιμολογίων και πληρωμών',
    matchBoardHint:
      'Σύρετε μια πληρωμή σε τιμολόγιο (ή αντίστροφα) για να κλείσετε υπόλοιπα. Μπορείτε επίσης να επιλέξετε ένα στοιχείο και να κάνετε κλικ στο αντίστοιχο.',
    matchBoardSearch: 'Αναζήτηση τιμολογίου ή πληρωμής',
    matchBoardInvoices: 'Τιμολόγια',
    matchBoardPayments: 'Πληρωμές',
    matchBoardLinks: 'Συνδέσεις',
    matchBoardOpen: 'Ανοιχτά',
    matchBoardClosed: 'Κλειστά',
    matchBoardExisting: 'Υπάρχουσες',
    matchBoardNew: 'Νέες',
    matchBoardEmptyInvoices: 'Δεν υπάρχουν τιμολόγια σε αυτό το φίλτρο.',
    matchBoardEmptyPayments: 'Δεν υπάρχουν πληρωμές σε αυτό το φίλτρο.',
    matchBoardEmptyLinks: 'Δεν υπάρχουν συνδέσεις.',
    matchBoardNoOverlap: 'Δεν υπάρχει κοινό υπόλοιπο για αυτή τη σύνδεση.',
    matchBoardApply: 'Εφαρμογή συνδέσεων',
    matchBoardApplyConfirm:
      'Να καταχωρηθούν οι νέες συνδέσεις και οι αποσυνδέσεις;',
    matchBoardApplied: 'Οι συνδέσεις ενημερώθηκαν.',
    matchBoardUnlink: 'Αποσύνδεση',
    matchBoardUndo: 'Αναίρεση',
    matchBoardRemaining: 'Υπόλοιπο',
    matchBoardUnallocated: 'Αδιάθετο',
    matchBoardDropHere: 'Αφήστε εδώ για σύνδεση',
  },
  categories: {
    title: 'Κατηγορίες Τιμολογίων',
    new: 'Νέα Κατηγορία',
    edit: 'Επεξεργασία Κατηγορίας',
    name: 'Όνομα',
    description: 'Περιγραφή',
    active: 'Ενεργή',
    inactive: 'Ανενεργή',
    deactivate: 'Απενεργοποίηση',
    requiredName: 'Το όνομα είναι υποχρεωτικό.',
    saveSuccess: 'Η κατηγορία αποθηκεύτηκε επιτυχώς.',
  },
  expenseCategories: {
    title: 'Κατηγορίες εξόδων μεταφοράς',
    new: 'Νέα κατηγορία',
    edit: 'Επεξεργασία κατηγορίας',
    name: 'Όνομα',
    description: 'Περιγραφή',
    active: 'Ενεργή',
    inactive: 'Ανενεργή',
    deactivate: 'Απενεργοποίηση',
    requiredName: 'Το όνομα είναι υποχρεωτικό.',
    saveSuccess: 'Η κατηγορία αποθηκεύτηκε επιτυχώς.',
    emptyTitle: 'Δεν υπάρχουν κατηγορίες εξόδων',
    emptyHint: 'Προσθέστε κατηγορίες όπως ναύλος, THC, εκτελωνισμός.',
  },
  companyExpenseCategories: {
    title: 'Κατηγορίες δαπανών',
    new: 'Νέα κατηγορία',
    edit: 'Επεξεργασία κατηγορίας',
    name: 'Όνομα',
    description: 'Περιγραφή',
    active: 'Ενεργή',
    inactive: 'Ανενεργή',
    deactivate: 'Απενεργοποίηση',
    requiredName: 'Το όνομα είναι υποχρεωτικό.',
    saveSuccess: 'Η κατηγορία αποθηκεύτηκε επιτυχώς.',
    emptyTitle: 'Δεν υπάρχουν κατηγορίες δαπανών',
    emptyHint: 'Προσθέστε κατηγορίες όπως ενοίκιο, μισθοδοσία, ενέργεια.',
  },
  companyExpenses: {
    title: 'Δαπάνες',
    new: 'Νέα δαπάνη',
    edit: 'Επεξεργασία δαπάνης',
    details: 'Δαπάνη',
    payablesTitle: 'Προς πληρωμή',
    summaryTitle: 'Δαπάνες ανά κατηγορία',
    expenseDate: 'Ημ/νία δαπάνης',
    dueDate: 'Ημ/νία λήξης',
    vatDueDate: 'Λήξη ΦΠΑ',
    vatDueDateHint: 'Κενό = ίδια με τη λήξη δαπάνης',
    vendorName: 'Προμηθευτής',
    documentNo: 'Αρ. παραστατικού',
    description: 'Περιγραφή',
    notes: 'Σημειώσεις',
    category: 'Κατηγορία',
    amount: 'Καθαρή αξία',
    vatRate: 'ΦΠΑ %',
    vatAmount: 'Ποσό ΦΠΑ',
    gross: 'Μικτό',
    type: 'Τύπος',
    status: 'Κατάσταση',
    paid: 'Πληρωμένο',
    remaining: 'Υπόλοιπο',
    statuses: {
      UNPAID: 'Απλήρωτη',
      PARTIAL: 'Μερική',
      PAID: 'Εξοφλημένη',
    },
    filters: {
      all: 'Όλες',
      unpaid: 'Απλήρωτες',
      partial: 'Μερικές',
      paid: 'Εξοφλημένες',
      open: 'Ανοιχτές',
    },
    searchPlaceholder: 'Αναζήτηση (προμηθευτής, αρ. παραστατικού)',
    selectCategory: '— Επιλέξτε κατηγορία —',
    paymentsSection: 'Πληρωμές',
    addPayment: 'Προσθήκη πληρωμής',
    removePayment: 'Αφαίρεση',
    paymentDate: 'Ημ/νία πληρωμής',
    paymentNet: 'Καθαρή αξία',
    paymentVat: 'ΦΠΑ',
    noPayments: 'Δεν υπάρχουν πληρωμές.',
    overdue: 'Ληξιπρόθεσμες',
    due7Days: 'Επόμενες 7 ημέρες',
    later: 'Αργότερα',
    remainingNet: 'Υπόλ. καθαρό',
    remainingVat: 'Υπόλ. ΦΠΑ',
    remainingGross: 'Υπόλ. μικτό',
    kindNet: 'Καθαρή αξία',
    kindVat: 'ΦΠΑ',
    kindBoth: 'Σύνολο',
    month: 'Μήνας',
    year: 'Έτος',
    count: 'Πλήθος',
    requiredCategory: 'Η κατηγορία είναι υποχρεωτική.',
    requiredExpenseDate: 'Η ημερομηνία δαπάνης είναι υποχρεωτική.',
    requiredDueDate: 'Η ημερομηνία λήξης είναι υποχρεωτική.',
    requiredAmount: 'Η καθαρή αξία είναι υποχρεωτική.',
    saveSuccess: 'Η δαπάνη αποθηκεύτηκε επιτυχώς.',
    deleteConfirmTitle: 'Διαγραφή δαπάνης',
    deleteConfirmMessage: 'Να διαγραφεί η δαπάνη;',
    deleteSuccess: 'Η δαπάνη διαγράφηκε.',
    emptyTitle: 'Δεν υπάρχουν δαπάνες',
    emptyHint: 'Καταχωρίστε γενικά έξοδα της εταιρίας.',
    emptyPayables: 'Δεν υπάρχουν ανοιχτές υποχρεώσεις.',
  },
  shipmentFiles: {
    title: 'Φάκελοι μεταφοράς',
    new: 'Νέος φάκελος',
    edit: 'Επεξεργασία φακέλου',
    details: 'Φάκελος μεταφοράς',
    fileNo: 'Αρ. φακέλου',
    fileNoHint: 'Ο αριθμός εκδίδεται αυτόματα κατά την αποθήκευση.',
    customer: 'Πελάτης',
    blNo: 'B/L',
    vessel: 'Πλοίο',
    port: 'Λιμάνι',
    arrivalDate: 'Ημ/νία άφιξης',
    notes: 'Σημειώσεις',
    status: 'Κατάσταση',
    statuses: {
      OPEN: 'Ανοιχτός',
      INVOICED: 'Τιμολογημένος',
    },
    filters: {
      all: 'Όλοι',
      open: 'Ανοιχτοί',
      invoiced: 'Τιμολογημένοι',
    },
    searchPlaceholder: 'Αναζήτηση (αριθμός, container, B/L, πελάτης)',
    containersSection: 'Containers',
    containerNo: 'Αριθμός container',
    addContainer: 'Προσθήκη container',
    removeContainer: 'Αφαίρεση',
    expensesSection: 'Έξοδα',
    expenseCategory: 'Κατηγορία εξόδου',
    expenseInvoiceNo: 'Αρ. τιμολογίου',
    expenseAmount: 'Έξοδο',
    vatRate: 'ΦΠΑ %',
    vatAmount: 'Ποσό ΦΠΑ',
    billable: 'Χρεώνεται',
    addExpense: 'Προσθήκη εξόδου',
    editExpense: 'Επεξεργασία εξόδου',
    removeExpense: 'Αφαίρεση',
    expenseModalSave: 'Αποθήκευση εξόδου',
    allContainers: 'Όλος ο φάκελος',
    selectCategory: '— Επιλέξτε κατηγορία —',
    selectCustomer: '— Επιλέξτε πελάτη —',
    selectContainer: '— Container —',
    documentsSection: 'Έγγραφα',
    uploadDocument: 'Ανέβασμα',
    downloadDocument: 'Κατέβασμα',
    deleteDocument: 'Αφαίρεση',
    noDocuments: 'Δεν υπάρχουν έγγραφα.',
    saveFirstForDocuments: 'Αποθηκεύστε τον φάκελο για να ανεβάσετε έγγραφα.',
    totalsSection: 'Σύνολα',
    totalExpenses: 'Σύνολο εξόδων',
    totalVat: 'Σύνολο ΦΠΑ',
    totalGross: 'Σύνολο με ΦΠΑ',
    billableTotal: 'Προς τιμολόγηση',
    createInvoice: 'Δημιουργία τιμολογίου',
    invoiceDialogTitle: 'Τιμολόγηση φακέλου',
    linkedInvoice: 'Τιμολόγιο',
    viewInvoice: 'Προβολή τιμολογίου',
    lockedHint: 'Ο φάκελος είναι τιμολογημένος. Τα έξοδα και τα container δεν αλλάζουν.',
    softDelete: 'Ακύρωση',
    softDeleteConfirm: 'Να ακυρωθεί ο φάκελος μεταφοράς; Τα έγγραφα θα διαγραφούν.',
    softDeleteSuccess: 'Ο φάκελος ακυρώθηκε.',
    softDeleteBlocked:
      'Ο τιμολογημένος φάκελος δεν μπορεί να ακυρωθεί. Ακυρώστε πρώτα το τιμολόγιο.',
    createSuccess: 'Ο φάκελος δημιουργήθηκε επιτυχώς.',
    updateSuccess: 'Ο φάκελος ενημερώθηκε επιτυχώς.',
    invoiceSuccess: 'Το τιμολόγιο δημιουργήθηκε επιτυχώς.',
    requiredCustomer: 'Το πεδίο «Πελάτης» είναι υποχρεωτικό.',
    requiredContainer: 'Πρέπει να υπάρχει τουλάχιστον ένα container.',
    requiredExpenseCategory: 'Η κατηγορία εξόδου είναι υποχρεωτική.',
    requiredExpenseAmount: 'Το ποσό εξόδου είναι υποχρεωτικό.',
    noBillableExpenses: 'Δεν υπάρχουν χρεώσιμες γραμμές για τιμολόγηση.',
    emptyTitle: 'Δεν υπάρχουν φάκελοι μεταφοράς',
    emptyHint: 'Δημιουργήστε έναν φάκελο για να συγκεντρώσετε τα έξοδα μεταφοράς.',
    view: 'Προβολή',
    editAction: 'Επεξεργασία',
  },
  invoices: {
    title: 'Τιμολόγια / Χρεώσεις',
    new: 'Νέο Τιμολόγιο',
    edit: 'Επεξεργασία Τιμολογίου',
    details: 'Λεπτομέρειες Τιμολογίου',
    customer: 'Πελάτης',
    invoiceNo: 'Αρ.Τιμ',
    invoiceDate: 'Ημ/νία Τιμ.',
    dueDate: 'Ημ/νία Λήξης',
    daysDue: 'Ημ. καθυστ.',
    category: 'Κατηγορία',
    description: 'Περιγραφή',
    notes: 'Παρατηρήσεις',
    linesSection: 'Γραμμές Χρέωσης',
    netAmount: 'Καθαρή αξία',
    vatRate: 'ΦΠΑ %',
    vatAmount: 'ΦΠΑ',
    lineTotal: 'Σύνολο',
    shipmentFile: 'Φάκελος μεταφοράς',
    charges: 'Χρεώσεις',
    paid: 'Πληρ.',
    outstanding: 'Υπόλ.',
    listInvoiceCountOne: '{count} τιμολόγιο',
    listInvoiceCount: '{count} τιμολόγια',
    status: 'Κατάσταση',
    statuses: {
      UNPAID: 'Ανεξόφλητο',
      PARTIALLY_PAID: 'Μερικώς Εξ.',
      PAID: 'Εξοφλημένο',
      OVERDUE: 'Ληξιπρόθεσμο',
    },
    filters: {
      dateFrom: 'Από',
      dateTo: 'Έως',
      paid: 'Εξοφλημένα',
      unpaid: 'Ανεξόφλητα',
      overdue: 'Ληξιπρόθεσμα',
      all: 'Όλα',
      allStatuses: 'Όλες οι καταστάσεις',
    },
    searchPlaceholder: 'Αναζήτηση (αριθμός, πελάτης, σημειώσεις)',
    requiredCustomer: 'Το πεδίο "Πελάτης" είναι υποχρεωτικό.',
    requiredInvoiceNo: 'Ο αριθμός τιμολογίου είναι υποχρεωτικός.',
    requiredInvoiceDate: 'Η ημερομηνία τιμολογίου είναι υποχρεωτική.',
    requiredDueDate: 'Η ημερομηνία λήξης είναι υποχρεωτική.',
    requiredLines: 'Πρέπει να υπάρχει τουλάχιστον μία γραμμή.',
    copyAgreement: 'Φόρτωση γραμμών συμφωνίας',
    agreementCopied: 'Οι γραμμές συμφωνίας αντιγράφηκαν στη φόρμα.',
    noAgreementToCopy: 'Ο πελάτης δεν έχει συμφωνία για αντιγραφή.',
    softDelete: 'Ακύρωση',
    softDeleteConfirm: 'Να ακυρωθεί το τιμολόγιο;',
    softDeleteSuccess: 'Η εγγραφή ακυρώθηκε επιτυχώς.',
    createSuccess: 'Το τιμολόγιο δημιουργήθηκε επιτυχώς.',
    selectCategory: '— Χωρίς κατηγορία —',
    selectCustomer: '— Επιλέξτε πελάτη —',
    view: 'Προβολή',
    editAction: 'Επεξεργασία',
    payAction: 'Πληρωμή',
  },
  payments: {
    title: 'Πληρωμές',
    new: 'Νέα Πληρωμή',
    edit: 'Επεξεργασία Πληρωμής',
    details: 'Λεπτομέρειες Πληρωμής',
    customer: 'Πελάτης',
    paymentDate: 'Ημ/νία Πληρ.',
    invoice: 'Αρ.Τιμ',
    description: 'Περιγραφή',
    notes: 'Παρατηρήσεις',
    linesSection: 'Γραμμές Πληρωμής',
    invoicePayments: 'Πληρ. Τιμ.',
    cashPayments: 'Πληρ. Μετρ.',
    paymentTotal: 'Σύνολο',
    listPaymentCountOne: '{count} πληρωμή',
    listPaymentCount: '{count} πληρωμές',
    unallocated: 'Μη Κατανεμημένη Πληρωμή',
    unallocatedOnly: 'Μόνο μη κατανεμημένες',
    unallocatedRemainder: 'Υπόλοιπο προς κατανομή',
    allocationsSection: 'Κατανομή σε τιμολόγια',
    allocationsHint:
      'Μοιράστε την πληρωμή σε ένα ή περισσότερα τιμολόγια. Χωρίς κατανομή η πληρωμή παραμένει μη κατανεμημένη.',
    addAllocation: '+ Προσθήκη τιμολογίου',
    allocated: 'Κατανεμημένα',
    multiAllocated: 'Πολλαπλά τιμολόγια',
    noInvoicesForCustomer: 'Δεν υπάρχουν τιμολόγια για αυτόν τον πελάτη.',
    allocationExceedsPayment:
      'Η κατανομή υπερβαίνει τις γραμμές πληρωμής.',
    noInvoice: '— Χωρίς τιμολόγιο —',
    selectCustomer: '— Επιλέξτε πελάτη —',
    selectInvoice: '— Επιλέξτε τιμολόγιο —',
    charges: 'Χρεώσεις',
    alreadyPaid: 'Ήδη Πληρωμένα',
    remaining: 'Υπόλοιπο',
    overpaymentWarning:
      'Η πληρωμή υπερβαίνει το υπόλοιπο του τιμολογίου. Ελέγξτε τα ποσά πριν την αποθήκευση.',
    allowOverpayment: 'Επιβεβαιώνω την υπερχρέωση',
    requiredCustomer: 'Το πεδίο "Πελάτης" είναι υποχρεωτικό.',
    requiredPaymentDate: 'Η ημερομηνία πληρωμής είναι υποχρεωτική.',
    requiredLines: 'Πρέπει να υπάρχει τουλάχιστον μία γραμμή.',
    searchPlaceholder: 'Αναζήτηση (πελάτης, τιμολόγιο, περιγραφή)',
    softDelete: 'Ακύρωση',
    softDeleteConfirm: 'Να ακυρωθεί η πληρωμή;',
    createSuccess: 'Η πληρωμή καταχωρήθηκε επιτυχώς.',
    view: 'Προβολή',
    editAction: 'Επεξεργασία',
    paidInvoicesTitle: 'Τιμολόγια που πληρώθηκαν',
    paidInvoicesOpen: 'Τιμολόγια πληρωμής',
    paidInvoicesEmpty: 'Η πληρωμή δεν έχει κατανομηθεί σε τιμολόγια.',
  },
  reports: {
    month: 'Μήνας',
    year: 'Έτος',
    exportExcel: 'Εξαγωγή Excel',
    exportPdf: 'Εξαγωγή PDF',
    viewMode: 'Προβολή',
    chargeInvoice: 'Χρεώσ. Τιμ.',
    chargeCash: 'Χρεώσ. Μετρ.',
    chargeTotal: 'Συν. Χρεώσ.',
    paymentInvoice: 'Πληρ. Τιμ.',
    paymentCash: 'Πληρ. Μετρ.',
    paymentTotal: 'Συν. Πληρ.',
    monthCharges: 'Χρεώσεις Μήνα',
    monthPayments: 'Πληρωμές Μήνα',
    yearlyTitle: 'Ετήσια ανάλυση ανά μήνα',
    yearlyTable: 'Πίνακας ανά μήνα',
    chartChargesPayments: 'Τιμολογήσεις, Μετρητά & Πληρωμές',
    chartTotals: 'Σύνολο χρεώσεων vs πληρωμές',
    seriesInvoiceCharges: 'Τιμολογήσεις',
    seriesCashCharges: 'Μετρητά',
    seriesPayments: 'Πληρωμές',
    seriesChargesTotal: 'Συν. χρεώσεων',
    seriesPaymentsTotal: 'Συν. πληρωμών',
    yearTotal: 'Σύνολο έτους',
    activeOnly: 'Ενεργοί Πελάτες',
    balancePositive: 'Υπόλοιπο > 0',
    balanceZero: 'Υπόλοιπο = 0',
    balanceNegative: 'Υπόλοιπο < 0',
    balanceAll: 'Όλα τα υπόλοιπα',
    viewTotal: 'Σύνολο',
    viewInvoice: 'Τιμολόγια',
    viewCash: 'Μετρητά',
    buckets: {
      notDue: 'Μη Ληξ.',
      d1_30: '1-30 ημ.',
      d31_60: '31-60 ημ.',
      d61_90: '61-90 ημ.',
      d90plus: '90+ ημ.',
    },
    drilldownTitle: 'Ανάλυση οφειλών',
    daysOverdue: 'Ημ. καθυστ.',
    originalAmount: 'Αρχ. Ποσό',
    dateFrom: 'Από',
    dateTo: 'Έως',
    asOf: 'Ημ/νία αναφοράς',
    bucket: 'Περίοδος',
    showInvoices: 'Εμφάνιση τιμολογίων',
    hideInvoices: 'Απόκρυψη τιμολογίων',
    apply: 'Εφαρμογή',
    allCustomers: 'Όλοι οι πελάτες',
    allCategories: 'Όλες οι κατηγορίες',
    chargesInvoice: 'Χρεώσ. Τιμ.',
    paymentsInvoiceCol: 'Πληρ. Τιμ.',
    outstandingInvoice: 'Υπ. Τιμ.',
    chargesCash: 'Χρεώσ. Μετρ.',
    paymentsCashCol: 'Πληρ. Μετρ.',
    outstandingCash: 'Υπ. Μετρ.',
    outstandingTotal: 'Συν. Υπόλ.',
    paymentAmount: 'Ποσό πληρωμής',
    allocatedAmount: 'Κατανεμημένα',
    unallocatedAmount: 'Μη κατανεμημένα',
    fullyUnallocated: 'Χωρίς κατανομή',
    partialUnallocated: 'Μερική κατανομή',
    allocationCount: 'Κατανομές',
    autoAllocate: 'Αυτόματη κατανομή',
    autoAllocatePreviewTitle: 'Προεπισκόπηση συνδέσεων',
    autoAllocatePreviewHint:
      'Πρώτα συνδέεται το ίδιο είδος (τιμολόγιο/μετρητά) και το περίσσευμα καλύπτει τον άλλο τύπο. Συμπεριλαμβάνονται και πληρωμές με μερική κατανομή.',
    autoAllocateRematch: 'Επανάληψη από την αρχή',
    autoAllocateRematchHint:
      'Διαγράφονται οι υπάρχουσες συνδέσεις του πελάτη και προτείνονται ξανά με βάση τα ποσά.',
    autoAllocateConfirmTitle: 'Επιβεβαίωση κατανομής',
    autoAllocateConfirmMessage:
      'Θα καταχωρηθούν μόνο οι επιλεγμένες συνδέσεις. Η ενέργεια δεν αναιρείται αυτόματα.',
    autoAllocateConfirmRematch:
      'Θα διαγραφούν οι υπάρχουσες συνδέσεις πληρωμών αυτού του πελάτη και θα καταχωρηθούν οι επιλεγμένες. Η ενέργεια δεν αναιρείται αυτόματα.',
    autoAllocateApply: 'Εφαρμογή συνδέσεων',
    autoAllocateSplit: 'Μοιρασμένη πληρωμή',
    autoAllocateSelected: 'Επιλεγμένες',
    autoAllocateNone:
      'Δεν βρέθηκαν συνδέσεις για τις πληρωμές με υπόλοιπο προς κατανομή.',
    autoAllocateMatched: 'Πληρωμές προς σύνδεση',
    autoAllocateUnmatched: 'Χωρίς ταίρι',
    autoAllocateLinks: 'Συνδέσεις',
    autoAllocateRule: 'Κανόνας',
    autoAllocateRuleExactOlder: 'Ακριβές ποσό (παλαιότερο)',
    autoAllocateRuleExactPrepay: 'Ακριβές ποσό (επόμενο, έως 30 ημ.)',
    autoAllocateRuleFifo: 'FIFO παλαιότερα',
    autoAllocateApplied: 'Οι συνδέσεις καταχωρήθηκαν.',
    autoAllocateSkipped: 'Παραλείφθηκαν (χωρίς υπόλοιπο ή διαγραμμένες)',
    autoAllocatePayment: 'Πληρωμή',
    autoAllocateInvoice: 'Τιμολόγιο',
    autoAllocateAmount: 'Ποσό σύνδεσης',
    autoAllocateRemainingAfter: 'Υπόλοιπο μετά',
    autoAllocatePaymentRemaining: 'Υπόλ. πληρωμής',
    autoAllocateInvoiceRemaining: 'Υπόλ. τιμολογίου',
    autoAllocateUnmatchedTitle: 'Πληρωμές χωρίς ταίρι',
    agreementMonthly: 'Συμφωνία / μήνα',
    expectedBilling: 'Αναμενόμενα',
    actualBilling: 'Πραγματική τιμολόγηση',
    variance: 'Απόκλιση',
    varianceAll: 'Όλες οι αποκλίσεις',
    variancePositive: 'Απόκλιση > 0',
    varianceZero: 'Απόκλιση = 0',
    varianceNegative: 'Απόκλιση < 0',
    varianceNonzero: 'Μόνο με απόκλιση',
    allMonths: 'Όλοι οι μήνες',
    periodMonths: 'Μήνες περιόδου',
    noAgreement: 'Χωρίς συμφωνία',
    shipmentFileNo: 'Αρ. φακέλου',
    shipmentStatus: 'Κατάσταση',
    shipmentStatusOpen: 'Ανοιχτός',
    shipmentStatusInvoiced: 'Τιμολογημένος',
    expenseNet: 'Καθαρή αξία',
    expenseVat: 'ΦΠΑ',
    expenseGross: 'Μικτό',
    billable: 'Χρεώσιμα',
    internal: 'Εσωτερικά',
    openCount: 'Ανοιχτοί',
    invoicedCount: 'Τιμολογημένοι',
    daysOpen: 'Ημέρες ανοιχτά',
    containers: 'Containers',
    port: 'Λιμάνι',
    vessel: 'Πλοίο',
    blNo: 'B/L',
    groupBy: 'Ομαδοποίηση',
    groupByPort: 'Λιμάνι',
    groupByVessel: 'Πλοίο',
    searchContainerBl: 'Αναζήτηση container ή B/L',
    searchMinChars: 'Πληκτρολογήστε τουλάχιστον 2 χαρακτήρες',
    lineCount: 'Γραμμές',
    fileCount: 'Φάκελοι',
    openBillable: 'Χρεώσιμα σε ανοιχτούς',
    companyExpenseVendor: 'Προμηθευτής',
    companyExpenseDocumentNo: 'Αρ. παραστατικού',
    companyExpensePaid: 'Πληρωμένο',
    companyExpenseRemaining: 'Υπόλοιπο',
    companyExpensePaymentDate: 'Ημ/νία πληρωμής',
    companyExpenseKindNet: 'Καθαρή αξία',
    companyExpenseKindVat: 'ΦΠΑ',
    companyExpenseKindBoth: 'Σύνολο',
    companyExpenseDaysOverdue: 'Ημέρες καθυστέρησης',
    companyExpenseTypeTitle: 'Τύπος παραστατικού',
    companyExpenseSettlementTitle: 'Κατάσταση εξόφλησης',
  },
  mydata: {
    title: 'myDATA',
    connectionTitle: 'Σύνδεση ΑΑΔΕ',
    connectionHint:
      'Αποθηκεύστε τον χρήστη και το subscription key του myDATA για το ΑΦΜ της εταιρείας.',
    periodTitle: 'Έσοδα / Έξοδα / ΦΠΑ',
    periodHint:
      'Τα ποσά προέρχονται από συγχρονισμό με την ΑΑΔΕ. Δεν αλλάζουν τα εσωτερικά τιμολόγια ή δαπάνες.',
    dashboardTitle: 'myDATA',
    periodSelected: 'Επιλεγμένη περίοδος',
    yearPanelTitle: 'Έτος',
    quickActions: 'Ενέργειες',
    lastSyncLabel: 'Τελευταίος συγχρονισμός',
    goToSync: 'Συγχρονισμός',
    goToDocuments: 'Παραστατικά',
    goToDebts: 'ΦΠΑ',
    goToConnection: 'Σύνδεση',
    yearSectionTitle: 'Στοιχεία έτους',
    yearLabel: 'Έτος',
    yearPeriodLabel: 'Περίοδος',
    yearMonthsSynced: 'Μήνες',
    yearDocuments: 'Παραστατικά',
    yearSourceMonths: 'Άθροισμα συγχρονισμένων μηνών',
    yearSourceFullYear: 'Συγχρονισμός ολόκληρου έτους',
    yearSourceDocuments: 'Από παραστατικά',
    yearSourceEmpty: 'Χωρίς δεδομένα έτους',
    monthNamesShort: [
      'Ιαν',
      'Φεβ',
      'Μαρ',
      'Απρ',
      'Μάι',
      'Ιουν',
      'Ιουλ',
      'Αυγ',
      'Σεπ',
      'Οκτ',
      'Νοε',
      'Δεκ',
    ],
    sectionIncomeExpenseVat: 'Έσοδα, έξοδα και ΦΠΑ',
    sectionDebts: 'ΦΠΑ',
    debtsHint:
      'Δείτε ανά μήνα του έτους τι έχετε να πληρώσετε στο κράτος ή προς επιστροφή, και αναλύστε την επιλεγμένη περίοδο.',
    debtsYearTitle: 'Ανάλυση έτους',
    debtsYearHint:
      'Ανά μήνα και τρίμηνο: ΦΠΑ εκροών, εισροών και ποσό προς πληρωμή ή επιστροφή. Πατήστε γραμμή για λεπτομέρειες.',
    debtsYearEmpty: 'Δεν υπάρχουν συγχρονισμένοι μήνες για αυτό το έτος.',
    debtsYearPayableTotal: 'Σύνολο προς πληρωμή (μήνες)',
    debtsYearRefundTotal: 'Σύνολο προς επιστροφή (μήνες)',
    debtsQuarterTitle: 'Ανά τρίμηνο',
    debtsQuarterHint:
      'Άθροισμα συγχρονισμένων μηνών κάθε τριμήνου (Q1–Q4).',
    debtsQuarterLabel: 'Q{n}',
    debtsQuarterMonths: 'Μήνες {from}–{to}',
    debtsQuarterPartial: 'Μερικός συγχρονισμός ({synced}/3)',
    debtsQuarterEmpty: 'Χωρίς συγχρονισμένους μήνες',
    debtsColOutputVat: 'Εκροές ΦΠΑ',
    debtsColInputVat: 'Εισροές ΦΠΑ',
    debtsColDue: 'Ποσό',
    debtsColMeaning: 'Σημασία',
    debtsMonthNotSynced: 'Χωρίς συγχρονισμό',
    debtsMonthZero: 'Μηδενικό υπόλοιπο',
    debtsPeriodDetail: 'Λεπτομέρεια επιλεγμένης περιόδου',
    sectionNetResult: 'Καθαρό αποτέλεσμα και συγκρίσεις',
    sectionCharts: 'Γραφήματα',
    sectionChartsHint:
      'Οπτική ανάλυση των συγχρονισμένων ποσών myDATA (όχι εσωτερικά τιμολόγια BalanceFlow).',
    chartComparisonTitle: 'Σύγκριση με προηγούμενη περίοδο',
    chartComparisonHint:
      'Συγκρίνει έσοδα, έξοδα, καθαρό αποτέλεσμα και ΦΠΑ της επιλεγμένης περιόδου με την αμέσως προηγούμενη (ίδιο μήνα/τρίμηνο πριν).',
    chartMixTitle: 'Σύνθεση περιόδου',
    chartMixHint:
      'Δείχνει πώς κατανέμονται στην επιλεγμένη περίοδο τα καθαρά έσοδα, τα καθαρά έξοδα, ο ΦΠΑ εκροών και ο ΦΠΑ εισροών.',
    chartVatCodesTitle: 'Ανάλυση κωδικών δήλωσης ΦΠΑ (Φ2)',
    chartVatCodesHint:
      'Κωδικοί της περιοδικής δήλωσης ΦΠΑ όπως τους επιστρέφει η ΑΑΔΕ· χωριστά σε πωλήσεις και αγορές.',
    chartMonthlyTitle: 'Ανά μήνα',
    chartMonthlyHint:
      'Έσοδα, έξοδα και καθαρό αποτέλεσμα ανά μήνα του επιλεγμένου έτους, από συγχρονισμένα μηνιαία σύνολα myDATA.',
    chartMonthlyEmpty: 'Δεν υπάρχουν συγχρονισμένοι μήνες για γράφημα.',
    vatCodesSalesTitle: 'Πωλήσεις (εκροές)',
    vatCodesSalesHint:
      'Κωδικοί εκροών: φορολογητέα αξία πωλήσεων (π.χ. 303) και αντίστοιχος ΦΠΑ (π.χ. 333).',
    vatCodesPurchasesTitle: 'Αγορές (εισροές)',
    vatCodesPurchasesHint:
      'Κωδικοί εισροών: αγορές/δαπάνες (π.χ. 361, 366) και ΦΠΑ που εκπίπτει (π.χ. 381, 386).',
    vatCodesAdjustmentsTitle: 'Προσαρμογές',
    vatCodesAdjustmentsHint:
      'Ειδικοί κωδικοί προσαρμογής της δήλωσης ΦΠΑ (π.χ. 348, 349) που επηρεάζουν την εκτίμηση οφειλής.',
    vatCodesOtherTitle: 'Λοιποί κωδικοί',
    vatCodesOtherHint:
      'Κωδικοί που δεν εντάσσονται σαφώς σε εκροές, εισροές ή προσαρμογές.',
    chartCurrentPeriod: 'Τρέχουσα',
    chartPreviousPeriod: 'Προηγούμενη',
    vatCode: 'Κωδικός',
    vatCodeDescription: 'Περιγραφή',
    vatCodeLabels: {
      '301': 'Εκροές με ΦΠΑ 13%',
      '302': 'Εκροές με ΦΠΑ 6%',
      '303': 'Εκροές με ΦΠΑ 24%',
      '304': 'Εκροές με ΦΠΑ 17%',
      '305': 'Εκροές με ΦΠΑ 9%',
      '306': 'Εκροές με ΦΠΑ 4%',
      '308': 'Εκροές με ΦΠΑ 4% (ειδικές)',
      '309': 'Εκροές με ΦΠΑ 3%',
      '310': 'Απαλλασσόμενες / μηδενικός συντελεστής',
      '311': 'Σύνολο εκροών',
      '312': 'Κύκλος εργασιών (διακανονισμός)',
      '313': 'Πράξεις εκτός κύκλου εργασιών ΦΠΑ',
      '314': 'Ενδοκοινοτικές αποκτήσεις χωρίς έκπτωση',
      '315': 'Ενδοκοινοτικές λήψεις χωρίς έκπτωση',
      '331': 'ΦΠΑ εκροών 13%',
      '332': 'ΦΠΑ εκροών 6%',
      '333': 'ΦΠΑ εκροών 24%',
      '334': 'ΦΠΑ εκροών 17%',
      '335': 'ΦΠΑ εκροών 9%',
      '336': 'ΦΠΑ εκροών 4%',
      '338': 'ΦΠΑ εκροών 4% (ειδικές)',
      '339': 'ΦΠΑ εκροών 3%',
      '342': 'Ενδοκοινοτικές παροχές υπηρεσιών (βάση)',
      '345': 'Ενδοκοινοτικές παροχές υπηρεσιών (βάση)',
      '348': 'Εξαγωγές / απαλλαγές πλοίων & αεροσκαφών (βάση)',
      '349': 'Λοιπές εκροές χωρίς ΦΠΑ με δικαίωμα έκπτωσης (βάση)',
      '361': 'Αγορές / δαπάνες εσωτερικού',
      '362': 'Αγορές επενδυτικών αγαθών',
      '363': 'Λοιπές εισροές',
      '364': 'Ενδοκοινοτικές αποκτήσεις αγαθών',
      '365': 'Ενδοκοινοτικές λήψεις υπηρεσιών',
      '366': 'Εισαγωγές αγαθών',
      '381': 'ΦΠΑ εισροών (αγορές εσωτερικού)',
      '382': 'ΦΠΑ εισροών (επενδυτικά)',
      '383': 'ΦΠΑ εισροών (λοιπές)',
      '384': 'ΦΠΑ εισροών (ενδοκοινοτικές αποκτήσεις)',
      '385': 'ΦΠΑ εισροών (ενδοκοινοτικές υπηρεσίες)',
      '386': 'ΦΠΑ εισροών (εισαγωγές)',
    } as Record<string, string>,
    sectionSecure: 'Ασφαλής σύνδεση myDATA',
    freshFromAade: 'Ενημερωμένο από ΑΑΔΕ',
    staleHint:
      'Τα δεδομένα είναι παλαιότερα από 1 ώρα. Πατήστε «Ανανέωση από ΑΑΔΕ» για φρέσκα ποσά.',
    staleHintSyncPage:
      'Τα δεδομένα είναι παλαιότερα από 1 ώρα. Συγχρονίστε ξανά από τη σελίδα',
    syncHint:
      'Επιλέξτε περίοδο και πατήστε Έναρξη για ανάκτηση εσόδων, εξόδων, ΦΠΑ και παραστατικών από την ΑΑΔΕ.',
    syncPageLink: 'Συγχρονισμός',
    syncHistoryTitle: 'Ιστορικό συγχρονισμών',
    syncHistoryEmpty: 'Δεν υπάρχει ακόμα ιστορικό συγχρονισμού.',
    syncHistoryWhen: 'Ημερομηνία / ώρα',
    syncHistoryPeriod: 'Περίοδος',
    syncHistoryStatus: 'Κατάσταση',
    syncHistoryDocuments: 'Παραστατικά',
    syncStatusSuccess: 'Επιτυχία',
    syncStatusError: 'Σφάλμα',
    syncQueueTitle: 'Ουρά συγχρονισμού',
    syncQueueHint:
      'Βάλτε πολλούς μήνες ή ολόκληρο έτος στην ουρά. Εκτελούνται ένας-ένας, με παύση περίπου 3 λεπτά μεταξύ τους λόγω ορίων ΑΑΔΕ.',
    syncQueueEnqueueYear: 'Όλο το έτος στην ουρά',
    syncQueueEnqueueMonths: 'Επιλεγμένοι μήνες στην ουρά',
    syncQueueCancel: 'Ακύρωση ουράς',
    syncQueueEmpty: 'Δεν υπάρχει ενεργή ουρά συγχρονισμού.',
    syncQueueProgress: 'Πρόοδος',
    syncQueueJobPending: 'Σε αναμονή',
    syncQueueJobRunning: 'Εκτελείται',
    syncQueueJobCompleted: 'Ολοκληρώθηκε',
    syncQueueJobCancelled: 'Ακυρώθηκε',
    syncQueueJobFailed: 'Απέτυχε',
    syncQueueItemPending: 'Αναμονή',
    syncQueueItemRunning: 'Τρέχει',
    syncQueueItemSuccess: 'ΟΚ',
    syncQueueItemError: 'Σφάλμα',
    syncQueueItemCancelled: 'Ακυρώθηκε',
    syncQueueItemSkipped: 'Παραλείφθηκε',
    syncQueueSelectMonths: 'Μήνες για ουρά',
    syncQueueEnqueued: 'Προστέθηκε στην ουρά',
    syncQueueRateLimitNote:
      'Ενδεικτικά: 12 μήνες χρειάζονται περίπου 40 λεπτά ή περισσότερο.',
    syncQueueStartsIn: 'Ξεκινά σε',
    syncQueueStartsAt: 'Έναρξη',
    syncQueueWaitingCooldown: 'Αναμονή ορίου ΑΑΔΕ',
    syncQueueNextStart: 'Επόμενη έναρξη',
    syncTechShow: 'Εμφάνιση τεχνικού log',
    syncTechHide: 'Απόκρυψη τεχνικού log',
    syncTechHint:
      'Λεπτομέρειες κλήσεων ΑΑΔΕ και debug log — μόνο για τεχνικό έλεγχο.',
    syncSimpleRunning: 'Ο συγχρονισμός εκτελείται…',
    autoSyncing: 'Ανάκτηση δεδομένων από ΑΑΔΕ…',
    connectionConfigured: 'Σύνδεση ρυθμισμένη',
    connectionMissing: 'Λείπει σύνδεση',
    environmentLabel: 'Περιβάλλον',
    securityCallout:
      'Το subscription key αποθηκεύεται κρυπτογραφημένα και δεν επιστρέφεται ποτέ. Τα δεδομένα αφορούν μόνο το ΑΦΜ της εταιρείας σας.',
    netResult: 'Καθαρό αποτέλεσμα',
    netResultHint: 'Έσοδα (καθαρά) μείον έξοδα (καθαρά)',
    vsPrevious: 'Έναντι προηγούμενης περιόδου',
    previousPeriod: 'Προηγούμενη περίοδος',
    noPrevious: 'Δεν υπάρχει αποθηκευμένη προηγούμενη περίοδος για σύγκριση.',
    delta: 'Μεταβολή',
    vatNumber: 'ΑΦΜ εταιρείας',
    tenantName: 'Επιχείρηση',
    aadeUserId: 'Χρήστης ΑΑΔΕ',
    subscriptionKey: 'Subscription key',
    subscriptionKeyHint: 'Αφήστε κενό για να διατηρηθεί το αποθηκευμένο κλειδί.',
    subscriptionKeySet: 'Ορισμένο',
    subscriptionKeyMissing: 'Δεν έχει οριστεί',
    environment: 'Περιβάλλον',
    sandbox: 'Δοκιμαστικό',
    production: 'Παραγωγικό',
    registerLink: 'Εγγραφή / λήψη κλειδιού ΑΑΔΕ',
    registerLinkSandbox: 'Άνοιγμα φόρμας εγγραφής δοκιμαστικού περιβάλλοντος',
    registerLinkProduction: 'Άνοιγμα φόρμας εγγραφής παραγωγικού περιβάλλοντος',
    saveConnection: 'Αποθήκευση σύνδεσης',
    connectionSaved: 'Η σύνδεση αποθηκεύτηκε.',
    notConfigured: 'Δεν έχει ρυθμιστεί σύνδεση myDATA.',
    lastSync: 'Τελευταίος συγχρονισμός',
    lastSyncError: 'Τελευταίο σφάλμα',
    neverSynced: 'Δεν έχει γίνει ακόμα συγχρονισμός',
    dateFrom: 'Από',
    dateTo: 'Έως',
    month: 'Μήνας',
    quarter: 'Τρίμηνο',
    sync: 'Ανανέωση από ΑΑΔΕ',
    syncing: 'Συγχρονισμός…',
    syncStarting: 'Έναρξη συγχρονισμού με ΑΑΔΕ…',
    syncProgressHint:
      'Ο συγχρονισμός μπορεί να διαρκέσει λίγα λεπτά λόγω ορίων της ΑΑΔΕ.',
    syncModalTitle: 'Πρόοδος συγχρονισμού ΑΑΔΕ',
    syncModalReady:
      'Πατήστε «Έναρξη» για να καλέσετε τα API της ΑΑΔΕ για την επιλεγμένη περίοδο.',
    syncModalStart: 'Έναρξη',
    syncModalClose: 'Κλείσιμο',
    syncStepPending: 'Αναμονή',
    syncStepRunning: 'Σε εξέλιξη',
    syncStepSuccess: 'ΟΚ',
    syncStepEmpty: 'Κενό',
    syncStepError: 'Σφάλμα',
    syncStepSkipped: 'Παραλείφθηκε',
    syncApiLabel: 'API',
    syncRequestMethod: 'Μέθοδος',
    syncRequestUrl: 'URL',
    syncRequestParams: 'Παράμετροι',
    syncNoParams: 'Χωρίς παραμέτρους',
    syncDebugTitle: 'Debug console ΑΑΔΕ',
    syncDebugEmpty: 'Δεν υπάρχουν ακόμα καταγραφές. Πατήστε Έναρξη.',
    syncDebugCopy: 'Αντιγραφή',
    syncDebugCopied: 'Αντιγράφηκε',
    syncDebugHeaders: 'Headers',
    syncDebugBody: 'Σώμα / δεδομένα',
    syncDebugDb: 'Βάση δεδομένων',
    rateLimitCooldown: 'Αναμονή λόγω ορίου ΑΑΔΕ…',
    rateLimitCountdown: 'Επανάληψη σε',
    rateLimitTitle: 'Η ΑΑΔΕ περιόρισε τα αιτήματα (rate limit).',
    rateLimitTryAgainBefore: 'Δοκιμάστε ξανά σε περίπου',
    rateLimitTryAgainAfter: 'δευτερόλεπτα.',
    rateLimitCountdownHint:
      'Το κουμπί θα ενεργοποιηθεί αυτόματα όταν λήξει η αναμονή.',
    postSyncCooldownTitle:
      'Ο συγχρονισμός ολοκληρώθηκε. Απαιτείται σύντομη αναμονή.',
    postSyncCooldownBefore: 'Επόμενος συγχρονισμός σε',
    postSyncCooldownAfter: 'δευτερόλεπτα.',
    postSyncCooldownHint:
      'Η ΑΑΔΕ περιορίζει συχνά αιτήματα (~60δ). Το κουμπί θα ενεργοποιηθεί αυτόματα.',
    synced: 'Ο συγχρονισμός ολοκληρώθηκε.',
    noSummary: 'Δεν υπάρχουν αποθηκευμένα δεδομένα για αυτή την περίοδο.',
    incomeNet: 'Έσοδα (καθαρά)',
    expenseNet: 'Έξοδα (καθαρά)',
    outputVat: 'ΦΠΑ εκροών (από πωλήσεις)',
    inputVat: 'ΦΠΑ εισροών (από αγορές)',
    vatPayable: 'Προς πληρωμή',
    vatRefundable: 'Προς επιστροφή από το κράτος',
    vatBalance: 'ΦΠΑ προς κράτος',
    vatPayableHint:
      'Έχετε να πληρώσετε ΦΠΑ στην ΑΑΔΕ. Εκτίμηση από myDATA — όχι η επίσημη δήλωση Φ2.',
    vatRefundableHint:
      'Πιστωτικό υπόλοιπο ΦΠΑ (προς επιστροφή ή συμψηφισμό). Εκτίμηση από myDATA — όχι η επίσημη δήλωση Φ2.',
    debtsPeriod: 'Περίοδος',
    debtsFormula: 'ΦΠΑ εκροών − ΦΠΑ εισροών = ποσό προς πληρωμή ή επιστροφή',
    debtsNoCodes: 'Δεν υπάρχουν κωδικοί ΦΠΑ για αυτή την περίοδο.',
    debtsAmount: 'Ποσό',
    documents: 'Παραστατικά',
    documentsHint:
      'Παραστατικά myDATA για την επιλεγμένη περίοδο (έσοδα / έξοδα).',
    searchDocuments: 'Αναζήτηση MARK, ΑΦΜ, σειράς…',
    direction: 'Κατεύθυνση',
    directionAll: 'Όλα',
    directionTransmitted: 'Διαβιβασμένα',
    directionReceived: 'Ληφθέντα',
    filterAll: 'Όλα',
    filterIncome: 'Έσοδα',
    filterExpense: 'Έξοδα',
    mark: 'MARK',
    issueDate: 'Ημ. έκδοσης',
    invoiceType: 'Είδος',
    seriesAa: 'Σειρά / ΑΑ',
    counterparty: 'Αντισυμβαλλόμενος',
    net: 'Καθαρή αξία',
    vat: 'ΦΠΑ',
    gross: 'Σύνολο',
    cancelled: 'Ακυρωμένο',
    openDocument: 'Άνοιγμα',
    documentTitle: 'Κάρτα παραστατικού',
    backToPeriod: 'Πίσω στην περίοδο',
    identity: 'Ταυτότητα',
    uid: 'UID',
    cancelledByMark: 'Ακυρώθηκε από MARK',
    qrCode: 'QR ΑΑΔΕ',
    openQr: 'Άνοιγμα QR ΑΑΔΕ',
    downloadPdf: 'Λήψη PDF',
    downloadingPdf: 'Λήψη…',
    pdfHtmlViewerOpened:
      'Ο πάροχος άνοιξε HTML προβολή με έλεγχο «Verify you are human». Ολοκληρώστε τον έλεγχο και μετά: Εκτύπωση → Αποθήκευση ως PDF.',
    pdfBundleTitle: 'Μαζική λήψη PDF',
    pdfBundleHint:
      'Κατεβάστε σε ένα αρχείο ZIP όλα τα επίσημα PDF παρόχου για τον επιλεγμένο μήνα.',
    pdfBundleTotalDocs: 'Παραστατικά μήνα',
    pdfBundleWithPdf: 'Με επίσημο PDF',
    pdfBundleWithoutPdf: 'Χωρίς επίσημο PDF',
    pdfBundleNote:
      'Περιλαμβάνονται μόνο παραστατικά όπου ο πάροχος δίνει πραγματικό αρχείο PDF. Αν ο πάροχος ανοίγει HTML viewer (Εκτύπωση → Αποθήκευση ως PDF), αυτά δεν μπαίνουν στο ZIP.',
    pdfBundleDownload: 'Λήψη ZIP',
    pdfBundleDownloading: 'Προετοιμασία ZIP…',
    pdfBundleDownloaded: 'Η λήψη του ZIP ξεκίνησε.',
    pdfBundleDownloadedPartial:
      'Κατέβηκαν {included} από {total} PDF. Στο ZIP υπάρχει `readme.txt` με τις λεπτομέρειες — δοκιμάστε ξανά αργότερα για τα υπόλοιπα (όρια παρόχου).',
    pdfBundleRefresh: 'Ανανέωση',
    printCard: 'Εκτύπωση κάρτας',
    pdfUnavailable:
      'Δεν υπάρχει επίσημο PDF παρόχου για αυτό το παραστατικό. Μπορείτε να ανοίξετε την προβολή ΑΑΔΕ ή να εκτυπώσετε την κάρτα.',
    issuer: 'Εκδότης',
    counterpart: 'Λήπτης',
    parties: 'Συμβαλλόμενοι',
    name: 'Επωνυμία',
    country: 'Χώρα',
    branch: 'Εγκατάσταση',
    address: 'Διεύθυνση',
    header: 'Επικεφαλίδα',
    currency: 'Νόμισμα',
    lines: 'Γραμμές',
    lineNo: 'Γραμμή',
    description: 'Περιγραφή',
    vatCategory: 'Κατ. ΦΠΑ',
    classification: 'Χαρακτηρισμός',
    payments: 'Τρόποι πληρωμής',
    paymentAmount: 'Ποσό',
    paymentType: 'Τύπος',
    totals: 'Σύνολα',
    syncedAt: 'Τελ. συγχρονισμός',
    noLines: 'Δεν υπάρχουν γραμμές παραστατικού.',
    noPayments: 'Δεν έχουν καταχωρηθεί τρόποι πληρωμής.',
    emptyValue: '—',
    noDocuments: 'Δεν βρέθηκαν παραστατικά για την περίοδο.',
    emptySyncHint:
      'Ο συγχρονισμός ολοκληρώθηκε, αλλά η ΑΑΔΕ δεν επέστρεψε ποσά ή παραστατικά για αυτή την περίοδο. Ελέγξτε ότι το ΑΦΜ στο προφίλ εταιρείας είναι σωστό και ότι στο επιλεγμένο περιβάλλον (δοκιμαστικό/παραγωγικό) υπάρχουν δεδομένα για το ΑΦΜ.',
    missingVat: 'Ορίστε πρώτα το ΑΦΜ στο προφίλ της εταιρείας.',
  },
  toasts: {
    loginSuccess: 'Επιτυχής σύνδεση',
    logoutSuccess: 'Αποσυνδεθήκατε επιτυχώς',
    saveSuccess: 'Οι αλλαγές αποθηκεύτηκαν επιτυχώς',
    saveError: 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση',
    customerCreated: 'Ο πελάτης δημιουργήθηκε επιτυχώς.',
    agreementSaved: 'Η συμφωνία αποθηκεύτηκε επιτυχώς.',
  },
} as const;

export type TranslationTree = typeof el;
